import { Autocomplete, TextField, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useDispatch } from "react-redux";
import {
  setDuplicateFrom,
  setDuplicateTo,
  // setEndDate,
} from "../../../../../features/engagementIncentivesSlice";
import dayjs from "dayjs";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { useSelector } from "react-redux";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const generateLast24Months = () => {
  const now = new Date();
  return Array.from({ length: 24 }).map((_, i) => {
    const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return {
      label: `${month}/${year}`,
      month,
      year,
    };
  });
};

const generateNext3Months = () => {
  const now = new Date();
  const startMonthOffset = now.getDate() <= 15 ? 0 : 1; // Include current month only if today's date is 15 or less

  return Array.from({ length: 4 - startMonthOffset }).map((_, i) => {
    const date = new Date(
      now.getFullYear(),
      now.getMonth() + i + startMonthOffset,
      1
    );
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return {
      label: `${month}/${year}`,
      month,
      year,
    };
  });
};

const Period = () => {
  const dispatch = useDispatch();
  const monthOptions = generateLast24Months();
  const monthOptionsForDuplicateTo = generateNext3Months();
  const duplicateTo = useSelector(
    (state: any) => state.engagementIncentives?.duplicateTo
  );
  const handleDuplicateFromSelect = (value: any) => {
    if (!value?.month || !value?.year) {
      dispatch(setDuplicateFrom({ startDate: null, endDate: null }));
      return;
    }

    const startDate = `${value.year}-${value.month}-01`;
    const endDate = dayjs(`${value.year}-${value.month}-01`)
      .endOf("month")
      .format("YYYY-MM-DD");

    dispatch(setDuplicateFrom({ startDate, endDate }));
  };
  const handleDuplicateToSelect = (value: any) => {
    if (!value?.month || !value?.year) {
      dispatch(setDuplicateTo(null));
      return;
    }

    const date = `${value.year}-${value.month}-01`;
    dispatch(setDuplicateTo(date));
  };

  return (
    <Box mt={4}>
      <Typography>Period</Typography>
      <Stack mt={2} flexDirection={"row"} gap={2}>
        <Autocomplete
          disablePortal={false}
          options={monthOptions}
          fullWidth
          sx={{ marginTop: "8px" }}
          onChange={(_, value) => handleDuplicateFromSelect(value)}
          size="small"
          renderInput={(params) => (
            <TextField
              placeholder="Choose origin month to copy data from"
              {...params}
              label="Duplicate From"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              color="secondary"
            />
          )}
        />

        <Autocomplete
          disablePortal={false}
          options={monthOptionsForDuplicateTo}
          fullWidth
          sx={{ marginTop: "8px" }}
          onChange={(_, value) => handleDuplicateToSelect(value)}
          size="small"
          value={
            monthOptionsForDuplicateTo.find(
              (option) => `${option.year}-${option.month}-01` === duplicateTo
            ) || null
          }
          renderInput={(params) => (
            <TextField
              placeholder="Choose target month to copy data to"
              {...params}
              label="Duplicate To"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              color="secondary"
            />
          )}
        />
      </Stack>
      <Typography mt={2} color={"#A0A0A0"} fontSize={12}>
        *Both fields are mandatory.
      </Typography>
    </Box>
  );
};

export default Period;
